import type { CoachingCoacheeCohortGoalsModel } from '@efdigital/ll-xceed-v2/routes/coaching/coachee/cohort/goals';
import Route from '@ember/routing/route';

export default class CoachingCoacheeCohortGoalsIndexRoute extends Route<CoachingCoacheeCohortGoalsModel> {
  model(): CoachingCoacheeCohortGoalsModel {
    return this.modelFor(
      'coaching.coachee.cohort.goals'
    ) as CoachingCoacheeCohortGoalsModel;
  }
}
